import { c as _c } from "react/compiler-runtime";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { useEffect } from "react";
export function useMinHeight(minHeight) {
  const $ = _c(6);
  const hasMinHeight = Boolean(minHeight);
  useMountEffect(() => {
    setMinHeight();
    return () => {
      unsetMinHeight();
    };
  });
  function setMinHeight() {
    if (!minHeight) {
      return;
    }
    document.body.style.setProperty("min-height", minHeight);
  }
  function unsetMinHeight() {
    document.body.style.removeProperty("min-height");
  }
  let t0;
  if ($[0] !== hasMinHeight || $[1] !== setMinHeight || $[2] !== unsetMinHeight) {
    t0 = () => {
      if (hasMinHeight) {
        setMinHeight();
      } else {
        unsetMinHeight();
      }
      return () => {
        unsetMinHeight();
      };
    };
    $[0] = hasMinHeight;
    $[1] = setMinHeight;
    $[2] = unsetMinHeight;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== hasMinHeight) {
    t1 = [hasMinHeight];
    $[4] = hasMinHeight;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
}